document.addEventListener('DOMContentLoaded', function() {
  const printShopDomain = window.printShopDomain;
  if (!printShopDomain) return;

  const popup = document.getElementById('print-shop-popup');
  const continueBtn = document.getElementById('print-shop-continue');
  const checkoutBtn = document.getElementById('print-shop-checkout');
  let targetUrl = '';
  let previouslyFocusedElement = null;

  // Function to check if cart has items
  async function hasItemsInCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.item_count > 0;
    } catch (error) {
      console.error('Error checking cart:', error);
      return false;
    }
  }

  // Function to show popup
  function showPopup(url) {
    targetUrl = url;
    previouslyFocusedElement = document.activeElement;
    popup.style.display = 'flex';
    // Focus the title first
    const title = document.getElementById('print-shop-popup-title');
    title.focus();
    // Announce the popup content
    const message = document.getElementById('print-shop-popup-message');
    message.setAttribute('aria-live', 'polite');
    setTimeout(() => {
      message.removeAttribute('aria-live');
    }, 1000);
  }

  // Function to hide popup
  function hidePopup() {
    popup.style.display = 'none';
    if (previouslyFocusedElement) {
      previouslyFocusedElement.focus();
    }
  }

  // Event listener for all links
  document.addEventListener('click', async function(e) {
    const link = e.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    try {
      const url = new URL(href);
      if (url.hostname === printShopDomain) {
        e.preventDefault();
        if (await hasItemsInCart()) {
          showPopup(href);
        } else {
          window.location.href = href;
        }
      }
    } catch (error) {
      // Not a valid URL, ignore
    }
  });

  // Continue button click handler
  continueBtn.addEventListener('click', function() {
    hidePopup();
    window.location.href = targetUrl;
  });

  // Checkout button click handler
  checkoutBtn.addEventListener('click', function() {
    hidePopup();
    window.location.href = '/checkout';
  });

  // Close popup when clicking outside
  popup.addEventListener('click', function(e) {
    if (e.target === popup) {
      hidePopup();
    }
  });

  // Handle keyboard events
  popup.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      hidePopup();
    }
    if (e.key === 'Tab') {
      // Keep focus trapped within popup
      const focusableElements = popup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];
      const activeElement = document.activeElement;

      if (e.shiftKey) {
        if (activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        if (activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
  });
}); 